import { Button } from '@material-ui/core';
import { KeyboardRounded, VpnKeyRounded } from '@material-ui/icons';
import { redeemCode } from '@webapps/business';
import { TextFieldButtonIcon, useAuth, useToast, useMutation } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import ConnexionCFA from 'components/Icons/ConnexionCFA';
import { useEffect, useState } from 'react';

const CFAKeyContainer = ({ refetch }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const { addToast } = useToast();

  const [code, setCode] = useState('');

  const {
    isSuccess: isSuccessRedeemCode,
    error: errorRedeemCode,
    mutateAsync: mutateRedeemCode,
  } = useMutation(redeemCode);

  const handleRedeemCode = async (e) => {
    const filteredCode = code.replace(/\s/g, '');
    await mutateRedeemCode({ code: filteredCode, id: idUser });
  }

  useEffect(() => {
    if (isSuccessRedeemCode) {
      addToast({
        status: 'success',
        message: 'Synchronisation avec le CFA réussie',
      });
      refetch();
    } else if (errorRedeemCode) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue lors de la synchronisation avec le CFA',
      });
    }
  }, [isSuccessRedeemCode, errorRedeemCode]);

  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <div className={cx(global.title, classes.title)}>Connectez-vous aux CFA</div>
        <div className={classes.form}>
          <TextFieldButtonIcon
            label="Insérer la clé du CFA"
            placeholder="Insérer la clé du CFA"
            type="text"
            fullWidth
            icon={<VpnKeyRounded />}
            buttonLabel="Se connecter"
            onChange={(e) => setCode(e.target.value)}
            onButtonClick={handleRedeemCode}
          />
        </div>

        <div className={classes.steps}>
          <div className={classes.step}>
            <div className={classes.stepNumber}>
              1
            </div>
            <div className={classes.stepText}>
              Connectez-vous aux CFA
            </div>

          </div>

          <div className={classes.step}>
            <div className={classes.stepNumber}>
              2
            </div>
            <div className={classes.stepText}>
              Connectez-vous aux CFA
            </div>

          </div>

          <div className={classes.step}>
            <div className={classes.stepNumber}>
              3
            </div>
            <div className={classes.stepText}>
              Connectez-vous aux CFA
            </div>

          </div>
        </div>

      </div>
      <div className={classes.right}>
        <ConnexionCFA
          style={{
            width: "auto",
            height: "140%",
            opacity: 0.42,
            // position: "absolute",
            // right: "0",
            // top: "40px",
            transform: "rotate(-2deg) translateY(30px)",
          }}
        />
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: "#e0edff",
    padding: "24px",
    width: "50%",
    borderRadius: "10px",
    position: "relative",
    display: "flex",
    overflow: "hidden",
    marginBottom: '30px',

    '@media (max-width: 1300px)': {
      width: '80%',
    },

    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    gap: "20px",
    width: "60%",

    '@media (max-width: 635px)': {
      width: '100%',
    },
  },
  title: {
    fontSize: "20px !important",
  },
  steps: {
    display: 'flex',
    flexDirection: 'row',
    gap: "16px",
  },
  step: {
    display: 'flex',
    flexDirection: 'row',
    gap: "6px",
    fontSize: "12px",
  },
  stepNumber: {
    color: "#0060F9",
    fontWeight: "bold",
    height: "16px",
    width: "16px",
    borderRadius: "50%",
    backgroundColor: "#A8CAFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px",
    fontSize: "10px",
  },
  stepText: {
    fontSize: "12px",
    color: "#152652",
    whiteSpace: "nowrap",
  },
  stepNumberText: {
    height: "12px",
    width: "12px",
    textAlign: "center",
  },
  right: {
    position: "absolute",
    width: "40%",
    height: "100%",
    right: "0",
    top: "0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    '@media (max-width: 635px)': {
      display: 'none',
    },
  },
});

export default CFAKeyContainer;